import { useEffect, useState } from 'react';

import { t } from 'i18next';
import { useDispatch } from 'react-redux';

import { useAppSelector } from '@/app/hooks';
import { ChuteSchedulerActions } from '@/app/slices/chuteScheduler';
import { Input } from '@/components/ui/input';
import {
  Tooltip,
  TooltipContent,
  TooltipTrigger,
} from '@/components/ui/tooltip';

import {
  format24hTo12h,
  parse12hTo24h,
  TIME_12H_REGEX,
} from '../utils/timeFormat';

type Props = { className?: string };

export const StartTime = ({ className }: Props) => {
  const dispatch = useDispatch();
  const { startTime } = useAppSelector((s) => s.chuteScheduler);

  const uiValue = format24hTo12h(startTime);
  const [text, setText] = useState(uiValue);
  useEffect(() => setText(uiValue), [uiValue]);

  const handleChange = (raw: string) => {
    const val = raw.toUpperCase();
    setText(val);
    if (TIME_12H_REGEX.test(val)) {
      dispatch({
        type: ChuteSchedulerActions.UPDATE_START_TIME,
        startTime: parse12hTo24h(val),
      });
    }
  };

  const isInvalid = !!text && !TIME_12H_REGEX.test(text);

  return (
    <div
      className={`${className ?? ''} label-input-group flex flex-col gap-1`.trim()}
    >
      <Tooltip>
        <TooltipTrigger
          render={
            <label className="w-fit cursor-help text-sm">
              {t('chuteScheduler.startTime')}
            </label>
          }
        />
        <TooltipContent>
          Start time for the first aspiration. Use 12-hour format (hh:mm AM/PM).
        </TooltipContent>
      </Tooltip>

      <Input
        type="text"
        placeholder="hh:mm AM"
        value={text}
        onChange={(e) => handleChange(e.target.value)}
        aria-invalid={isInvalid}
        className="w-full lg:w-28"
      />
    </div>
  );
};
